// @ts-ignore
type InputData = {
  id: string;
  text: string;
  textHtml: string;
  explanation: string | null;
  explanationHtml: string | null;
  isManual: boolean;
  modelType: string;
  type: string;
  image: any;
};

type OutputData = {
  data: {
    relationships: {
      association: {
        data: {
          id: number;
          type: string;
          attributes: {
            text: string;
            'text-html': string;
            explanation: string | null;
            'explanation-html': string | null;
            'is-manual': boolean;
            'model-type': string;
          };
          callbacks: {};
          correct: boolean;
          isDuped: boolean;
          relationships: {
            image: {
              data: any;
            };
          };
          saveData: {
            attributePathsToBeSaved: {};
            attributesPathsSaving: {};
          };
        };
      };
    };
  };
};

export default function convertFormat(input: InputData): OutputData {
  return {
    data: {
      relationships: {
        association: {
          data: {
            id: parseInt(input.id, 10),
            type: input.type,
            attributes: {
              text: input.text,
              'text-html': input.textHtml,
              explanation: input.explanation,
              'explanation-html': input.explanationHtml,
              'is-manual': input.isManual,
              'model-type': input.modelType,
            },
            callbacks: {},
            correct: true,
            isDuped: false,
            relationships: {
              image: {
                data: input.image,
              },
            },
            saveData: {
              attributePathsToBeSaved: {},
              attributesPathsSaving: {},
            },
          },
        },
      },
    },
  };
}
